import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Download, Trash2, Search } from "lucide-react";
import { toast } from "sonner";

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = () => api.get("/admin/newsletter").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!confirm("Delete subscription?")) return;
    await api.delete(`/admin/newsletter/${id}`);
    toast.success("Deleted"); load();
  };

  const exportCsv = async () => {
    const token = localStorage.getItem("eq_admin_token");
    const res = await fetch(`${API}/admin/newsletter/export/csv`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "newsletter.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  const filtered = items.filter((i) => i.email?.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-8">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-display font-black text-3xl" data-testid="admin-newsletter-title">Newsletter Subscribers</h1>
          <p className="text-neutral-500 mt-1">{items.length} subscribers</p>
        </div>
        <button onClick={exportCsv} className="btn-outline-eq text-sm" data-testid="newsletter-export"><Download className="w-4 h-4" /> Export CSV</button>
      </div>

      <div className="relative mt-6 max-w-md">
        <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-neutral-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search emails..."
               className="w-full pl-11 pr-4 py-3 rounded-full border border-neutral-200 bg-white focus:outline-none focus:border-sky-500" data-testid="newsletter-search" />
      </div>

      <div className="mt-6 bg-white rounded-2xl border border-neutral-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 text-neutral-500 text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-4 py-3">Email</th>
              <th className="text-left px-4 py-3">Subscribed</th>
              <th className="text-left px-4 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((i) => (
              <tr key={i.id} className="border-t border-neutral-100 hover:bg-neutral-50" data-testid={`newsletter-row-${i.id}`}>
                <td className="px-4 py-3">{i.email}</td>
                <td className="px-4 py-3 text-neutral-500 text-xs">{new Date(i.created_at).toLocaleString()}</td>
                <td className="px-4 py-3">
                  <button onClick={() => remove(i.id)} className="p-1.5 hover:bg-red-100 text-red-600 rounded" data-testid={`newsletter-delete-${i.id}`}><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={3} className="text-center py-16 text-neutral-500">No subscribers yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
